// extracted by mini-css-extract-plugin
export default {"DescriptionWithLink":"DescriptionWithLink_DescriptionWithLink__B5V5P","link":"DescriptionWithLink_link__-GuE1"};